

type SourceAccountIconProps = {
    className?: string
    width?: number
    height?: number
}
const SourceAccountIcon = ({ className = "#333", width = 32, height = 32 }: SourceAccountIconProps) => {
    return (
        <svg
        className={className}
            xmlns="http://www.w3.org/2000/svg"
            width={width}
            height={height}
            fill="currentColor"
            viewBox="0 0 32 32"
        >
            <path d="M25 11a5.008 5.008 0 0 0-4.899 4H11.9a5 5 0 1 0 0 2H20.1A5 5 0 1 0 25 11Zm0 8a3 3 0 1 1 3-3 3.003 3.003 0 0 1-3 3Z" />
            <path
                d="M0 0h32v32H0z"
                data-name="&lt;Transparent Rectangle&gt;"
                style={{
                    fill: "none",
                }}
            />
        </svg>
    )

}
export default SourceAccountIcon